import React from "react";
import { useSelector } from "react-redux";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { filterNonUCHAccounts } from "utils/account.util";
import { EVOKE_ROLES } from "static/constants";

const AccountFilter = ({
  displayAll = true,
  label = undefined,
  onChange,
  value,
  disabled = false,
  required = true,
}) => {
  const { accounts } = useSelector((state) => state.account);
  const filteredAccounts = filterNonUCHAccounts(accounts);
  const userRole = useSelector((state) => state.auth?.currentUser?.role);

  return (
    <>
      <FormControl fullWidth required={required}>
        <InputLabel id="account-select-label">{label || "Account"}</InputLabel>

        <Select
          labelId="account-select-label"
          id="account-select-helper"
          value={value || ""}
          label={label || "Account"}
          onChange={onChange}
          disabled={
            disabled ||
            (filteredAccounts?.length <= 1 && !EVOKE_ROLES.includes(userRole))
          }
        >
          {displayAll && filteredAccounts?.length > 1 && (
            <MenuItem value="all">All</MenuItem>
          )}
          {filteredAccounts?.map(({ name }, index) => (
            <MenuItem key={index} value={name}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default AccountFilter;
